import { render } from "./domiciliation-modal.vue?vue&type=template&id=4c95f868"
import script from "./domiciliation-modal.vue?vue&type=script&lang=js"
export * from "./domiciliation-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__